<template>
  <div>
    <div class="stay-pop" :class="page_style" id="stay-pop" v-if="popShow && !isFleetPCFunnel">
      <div class="bg" id="bg"></div>
      <div class="card">
        <div class="header">
          <p class="title" v-if="alertInfo.title">{{alertInfo.title}}</p>
          <img-v3 :src="require('../../images/icon_close.png')" alt="" class="pop-close" @click="closePop" />
        </div>
        <div class="desc">
          {{alertInfo.desc}}
        </div>
        <div class="btns">
          <p class="btn yes" :class="`${country}`" id="yes-btn" @click="closePop">{{alertInfo.btn || $t('确认')}}</p>
        </div>
      </div>
    </div>
    <el-dialog
      v-if="isFleetPCFunnel"
      :visible="popShow"
      :show-close="false"
      custom-class="pc-dialog-wrapper"
      width="384px">
      <div slot="title" class="header-title">
        <span class="title-text"><img-v3 :src="require('../../images/icon_notice@2x.png')" /><span>{{ alertInfo.title || '' }}</span></span>
        <img-v3 class="title-close" :src="require('../../images/icon-close-fleet@2x.png')" @click="popShow = false" />
      </div>
      <span>{{ alertInfo.desc || '' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="popShow = false">{{ alertInfo.btn || $t('确认') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["formItem", "idx", "alertInfo", "page_style"],
  data() {
    return {
      popShow: false,
    }
  },
  computed: {
    country() {
      const params = new URLSearchParams(location.search);
      return params.get("location_country");
    },
    // isFleetFunnel() {
    //   return this.page_style === "h5_funnel_fleet";
    // },
    isFleetPCFunnel() {
      return ["h5_funnel_fleet_pc"].includes(this.page_style);
    },
    pic_desc() {
      return this.formItem.pic_desc || {};
    },
  },
  mounted() {
    console.log(this.formItem);
  },
  methods: {
    closePop() {
      this.popShow = false
    }
  }
};
</script>
<style lang="scss" scoped>
.stay-pop {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999999;
  /* transform:  translateY(100%); */
  height: 100%;
  width: 100%;
  .bg {
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: hidden;
    opacity: 0.6;
    background: #0f1928;
  }
  .card {
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    padding-bottom: 1.7rem;
    box-sizing: border-box;
    border-radius: 0.36rem 0.36rem 0 0;
    background: #ffffff;
    .header {
      min-height: 1.2rem;
    }
    .pop-close {
      position: absolute;
      right: 0.36rem;
      top: 0.36rem;
      width: 0.48rem;
    }
    .title {
      padding: 0.33rem;
      font-size: 0.4rem;
      font-weight: bold;
      color: #333333;
    }
    .desc {
      padding: 0.05rem 0.33rem 0.33rem 0.33rem;
      font-size: 0.32rem;
      color: #666666;
      letter-spacing: 0;
      line-height: 0.38rem;
      a {
        font-size: 0.32rem;
        font-weight: 500;
        color: #ff7226;
      }
    }
    .btns {
      position: absolute;
      bottom: 0;
      width: 100%;
      box-sizing: border-box;
      padding: 0.32rem;
      font-size: 0.36rem;
      color: #ffffff;
      .btn {
        text-align: center;
      }
      .yes {
        height: 1.08rem;
        line-height: 1.08rem;
        font-weight: 700;
        background: #ff7226;
        border-radius: 0.12rem;
      }
      .no {
        margin-top: 0.32rem;
        font-size: 0.32rem;
        font-weight: 500;
        color: #666;
      }
    }
  }
  &.h5_funnel_fleet .card .btns .yes {
    background-image: linear-gradient(145deg, #FF7D41 0%, rgba(255,116,15,0.75) 99%);
    color: #ffffff;
    &.BR {
      background-image: linear-gradient(-46deg, #FFAE1E 0%, #FFCA00 100%);
      color: #333333;
    }
  }
}
</style>

